import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

const swiperOptions = {
  init: true,
  keyboard: true,
  speed: 1000,
  spaceBetween: 20,
  slidesPerView: 'auto',
  parallax: true,
  preloadImages: false,
  watchSlidesVisibility: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
}

export default {
  components: {
    Swiper
  },
  data: () => ({
    swiperRef: undefined
  }),
  directives: {
    'swiper-gallery': {
      inserted (el, binding, vnode) {
        const swiperRef = new Swiper(el, {
          init: true,
          keyboard: true,
          speed: 1000,
          spaceBetween: 20,
          slidesPerView: 'auto',
          parallax: true,
          preloadImages: false,
          watchSlidesVisibility: true,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          navigation: {
            nextEl: el.parentElement.querySelector('.swiper-button-next'),
            prevEl: el.parentElement.querySelector('.swiper-button-prev')
          }
        })
        vnode.context.$data.swiperRef = swiperRef
      },
      componentUpdated (el, binding, vnode) {
      },
      unbind (el, binding, vnode) {
        vnode.context.$data.swiperRef.destroy()
      }
    }
  }
}
